import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import logoSence from '../../assets/Logo_sence_blanco.png';
import Tooltip from "@mui/material/Tooltip";

/**
 * CourseCard Component
 * 
 * Replicación PIXEL-PERFECT basada en el mockup (IMAGEN 2).
 * Diseño compacto, colores sólidos, sombras definidas y bordes moderados.
 */
export const CourseCard = ({ item = null, moodle, lang, imgurl, categoryName }) => {
  const theme = useTheme();
  const navigation = useNavigate();

  const handleNavigation = () => {
    if (moodle && item) {
      moodle.setCurrentModules(null);
      navigation(`/detailcourse/${item.id}`);
    }
  };

  const title = item?.fullname || "Curso de muestra";
  const progress = item?.progress !== undefined ? Math.round(item.progress) : 0;
  const category = categoryName || "Categoría 1";
  const titleRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = titleRef.current;
    if (el) setIsTruncated(el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth);
  }, [title]);
  const displayImg = imgurl || "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800";

  return (
    <div className={`w-full  max-w-[340px] rounded-[10px] overflow-hidden transition-all duration-300 font-jost group ${
      theme.mode === 'dark' 
        ? 'bg-[#0f2844] border-gray-600 border-[1px] shadow-[0_4px_7px_rgba(0,15,37,0.4)]'
        : 'bg-white border-gray-100 border-none !border shadow-[0_4px_7px_rgba(0,15,37,0.92)]'
    }`}>
      
      {/* Sección Imagen con Overlay Oscuro */}
      <div className="relative aspect-video overflow-hidden">
        <img 
          src={displayImg} 
          alt={title} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        {/* Overlay Oscuro Permanente */}
        <div className="absolute inset-0 bg-black/40"></div>
        
        {/* Logo Sence si aplica */}
        {item && item.idnumber?.includes("sence") && (
          <div className="absolute right-3 bottom-3">
            <img src={logoSence} alt="logo-sence" className="w-16 h-auto opacity-90 drop-shadow-md" /> 
          </div>
        )}
      </div>

      {/* Contenido Compacto */}
      <div className="p-6 flex flex-col space-y-5">
        
        {/* Badge Dinámico WordPress */}
        <div className="flex">
          <span 
            className="text-[12px] font-semibold px-4 py-1.5 rounded-lg tracking-wide"
            style={{ 
              backgroundColor: '#1a4275', 
              color: theme?.colors?.TextColorCardBtn || '#ffffff' 
            }}
          >
            {category}
          </span>
        </div>

        {/* Título - Peso Visual Mockup */}
        <Tooltip title={isTruncated ? title : ""} placement="top" arrow disableHoverListener={!isTruncated} componentsProps={{ tooltip: { sx: { fontSize: "13px" } } }}>
          <h2 ref={titleRef} className={`text-[18px] font-semibold leading-tight line-clamp-1  ${
            theme.mode === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>
            {title}
          </h2>
        </Tooltip>

        {/* Sección de Progreso */}
        <div className="space-y-3">
          <div className="flex justify-between items-center text-[13px]">
            <span className="text-gray-500 dark:text-gray-400 font-light">Progreso</span>
            <span className={`font-light ${
              theme.mode === 'dark' ? 'text-white' : 'text-[#102a43]'
            }`}>{progress}% Completado</span>
          </div>
          
          {/* Barra de Progreso */}
          <div className={`w-full h-[6px] rounded-full overflow-hidden ${
            theme.mode === 'dark' ? 'bg-white/20' : 'bg-gray-100'
          }`}>
            <div 
              className="h-full rounded-full transition-all duration-1000 ease-out"
              style={{ width: `${progress}%`, background: "linear-gradient(to right, rgb(51, 86, 99) 1%, #6AB7D9 50%)" }}
            ></div>
          </div>
        </div>

        {/* Botón de Acción Dinámico */}
        <div className="pt-2">
          <button 
            onClick={handleNavigation}
            type="button"
            className="w-full py-4 text-[16px] font-semibold rounded-2xl transition-all duration-200 shadow-lg shadow-blue-500/20 hover:brightness-90 active:scale-[0.98]"
            style={{ 
              backgroundColor: '#1a4275', 
              color: theme?.colors?.TextColorCardBtn || '#ffffff' 
            }}
          >
            {lang?.Home?.course_btn || "Entrar al curso"}
          </button>
        </div>
      </div>
    </div>
  );
};
